import styles from "./index.module.less";
import { useEffect, useState, useRef, useCallback } from "react";
import classNames from "classnames";
import { useSafeState } from "ahooks";

export default function HBTabButton({
  // options: _options = [],
  options = [],
  value: _value,
  className,
  onChange,
  optionClass = {},
  style = {},
  size,
}) {
  const listRef = useRef(null);
  const [value, setValue] = useState(_value);
  const [bgStyle, setBgStyle] = useSafeState();
  // const [options, setOptions] = useState(_options);
  const calculateBgStyle = useCallback(() => {
    const el = listRef.current?.querySelector(".active");
    setBgStyle(
      el
        ? {
            width: `${el.offsetWidth}px`,
            left: `${el.offsetLeft}px`,
          }
        : null
    );
  }, [setBgStyle]);

  const onClick = useCallback(
    (option) => {
      onChange && onChange(option, option.value);
      setValue(option.value);
    },
    [onChange]
  );

  useEffect(() => {
    setValue(_value);
    // 异步是因为需要等待ui更新了才能获取到正确的状态
    setTimeout(() => {
      calculateBgStyle();
    }, 1);

    const onLoad = () => {
      calculateBgStyle();
    };

    window.addEventListener("load", onLoad);

    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, [_value, calculateBgStyle]);

  // useEffect(() => {
  //   const option = _options.find((option) => option.value === value);
  //   if (option?.firstClickKey) {
  //     localStorage.setItem(option.firstClickKey, true);
  //     dispatch({ type: "setSucaiIsRead", payload: true });
  //   }
  //   setOptions(
  //     _options.map((option) => {
  //       return {
  //         ...option,
  //         dot:
  //           option.firstClickKey && !localStorage.getItem(option.firstClickKey),
  //       };
  //     })
  //   );
  // }, [_options, dispatch, value]);

  return (
    <div
      className={classNames([
        styles.button,
        className,
        size === "small" ? styles.small : null,
      ])}
      style={style}
    >
      <div className={classNames([styles.bg, "bg"])} style={bgStyle} />
      <div className={styles.list} ref={listRef} data-value={value}>
        {options.map((option) => (
          <div
            data-value={option.value}
            key={option.value}
            className={classNames([
              styles.item,
              option.dot ? styles.dot : null,
              value === option.value ? "active" : null,
              optionClass[option.value] || null,
            ])}
            onClick={() => onClick(option)}
            style={
              value === option.value
                ? {
                    color: "#1E2023",
                    ...(option.style || {}),
                  }
                : { ...(option.style || {}) }
            }
          >
            {option.name}
          </div>
        ))}
      </div>
    </div>
  );
}
